import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { lighten, useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import * as patientSessionActions from "../../state/redux/patientSession";
import { deepCopyObject, getElapsedTimeString, OmniStringToDate } from "../../utils/helpers";
import PatientConditionDialog from "../dialogs/patientConditionDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const PatientConditions = props => {
  const { patientChart } = props;

  const [selectedCondition, setSelectedCondition] = useState(null);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (patientChart != null && patientChart.conditions != null) {
      setTitleText(
        Object.entries(patientChart.conditions).length === 1
          ? `${Object.entries(patientChart.conditions).length} Diagnosis`
          : `${Object.entries(patientChart.conditions).length} Diagnoses`,
      );
    } else setTitleText("");
  }, [patientChart]);

  const theme = useTheme();

  return (
    <Widget>
      <WidgetTitle title={"conditions"} text={titleText}>
        <OmniResponsiveButton
          tooltipTitle="Add New Condition"
          buttonText="Condition"
          loading={patientChart == null || patientChart.conditions == null}
          onClick={() => {
            setSelectedCondition("");
          }}
        />
      </WidgetTitle>

      {(patientChart == null || patientChart.conditions == null) && <WidgetSkeleton />}
      {patientChart != null && patientChart.conditions != null && (
        <WidgetList>
          {Object.entries(patientChart.conditions).map((condition, index) => {
            return (
              <ListItem
                key={`Condition${index}`}
                disableGutters={true}
                sx={[
                  {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: theme.spacing(1),
                    paddingRight: theme.spacing(1),
                    boxShadow: theme.shadows[1],
                    marginBottom: theme.spacing(1),
                    borderRadius: theme.spacing(1),
                    backgroundColor: theme.palette.foreground.main,
                    color: theme.palette.foreground.contrastText,
                    webkitUserSelect: "none",
                    userSelect: "none",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: lighten(theme.palette.secondary.main, 0.9),
                    },
                  },
                ]}
                onClick={() => {
                  setSelectedCondition(condition[0]);
                }}
              >
                <ListItemText
                  primary={
                    <div>
                      <Typography variant="overline">{`${getElapsedTimeString(
                        new Date(),
                        OmniStringToDate(condition[1].diagnosed),
                      )}`}</Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          marginTop: `-${theme.spacing(1.5)}`,
                          webkitUserSelect: "none",
                          userSelect: "none",
                        }}
                      >
                        {`${condition[0]}`}
                      </Typography>
                    </div>
                  }
                  secondary={
                    <Typography variant="body2">
                      {condition[1].note || "No additional information"}
                    </Typography>
                  }
                ></ListItemText>
                {/* <OmniEditButton
                  onClick={e => {
                    e.stopPropagation();
                    setSelectedCondition(condition[0]);
                  }}
                /> */}
              </ListItem>
            );
          })}
        </WidgetList>
      )}

      {selectedCondition != null && (
        <PatientConditionDialog
          open={selectedCondition != null}
          dialogTitle={`${selectedCondition === "" ? "New" : "Edit"} Condition`}
          condition={selectedCondition}
          allConditions={deepCopyObject(patientChart.conditions)}
          rowCount={5}
          onAccept={conditions => {
            //already Deep Copied
            props.updatePatientConditionsRequest(conditions);
            setSelectedCondition(null);
          }}
          onClose={() => {
            setSelectedCondition(null);
          }}
          editFieldsMetadata={"Add Condition"}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  patientId: state.patientSession.patientId,
  patientChart: state.patientSession.patientChart,
});

const mapDispatchToProps = {
  updatePatientConditionsRequest: patientSessionActions.updatePatientConditionsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientConditions);
